/* eslint-disable jsx-a11y/label-has-for,import/no-extraneous-dependencies */
import React from 'react';
import styledComponent from '../../../utils/styledComponent';

const StyledDiv = styledComponent('div', {
  '& label': {
    color: '#4a4a4a',
    display: 'block',
    fontSize: '18px',
    fontWeight: 'normal',
    marginBottom: '10px',
    width: 'auto',
  },
  '& select': {
    border: '1px solid #ccc',
    fontSize: '18px',
    height: '40px',
    marginBottom: '20px',
  },
});

const Select = ({
  id,
  name,
  label = '',
  value,
  onChange,
  placeholder,
  required = false,
  options = [],
}) => {
  return (
    <StyledDiv>
      {label && <label htmlFor={id}>{label}</label>}
      <select
        id={id}
        name={name}
        onChange={onChange}
        value={value}
        className="form-control"
        required={required}
      >
        <option value="">{placeholder}</option>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </StyledDiv>
  );
};

export default Select;
